export default "__VITE_ASSET__DUVkZUte__"